/* istanbul ignore file */
import BaseApi from '@lumapps/base-api';

export const translateApi = new BaseApi({
    path: 'translate',
});

/** Body params for the /translate/get endpoint */
interface TranslateParams {
    /** The text to translate */
    content: string;
    /** The language for the result (Format ISO639-1 Code). */
    targetLang: string;
    /** The text language (Format ISO639-1 Code). */
    sourceLang?: string;
    /** Whether the source format is html */
    isContentHTML?: boolean;
}

/**
 * Use gTranslate to translate a content using the /translate/get endpoint.
 * @see https://lumapps-api.stoplight.io/docs/lumapps-private-api/76cb58028a917-translate-text-alpha
 */
export const gTranslate = async ({ content, targetLang, sourceLang, isContentHTML }: TranslateParams) => {
    const { data } = await translateApi.post<{ contentText: string }>('get', {
        contentText: content,
        sourceFormat: isContentHTML ? 'html' : 'text',
        targetLang,
        sourceLang,
    });
    return data.contentText;
};

export const autoTranslationQueryKeys = {
    all: () => ['auto-translation'] as const,
    googleTranslate: (params?: TranslateParams) =>
        [...autoTranslationQueryKeys.all(), 'google-translate', params] as const,
};
